var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.onClick}},[_c('Icon',_vm._b({style:(_vm.style),attrs:{"color":!_vm.color ? '' : _vm.male ? 'royalblue' : 'crimson',"icon":_vm.male ? 'mdi:face-man-profile' : 'mdi:face-woman-profile'}},'Icon',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }